import type {FC} from 'react';

import {PortableText} from '@/modules/foundation/sanity/portable-text';

import ArticleList, {
	articleListLatestDescriptionPortableTextOverrides,
} from '../../components/article-list';

import {articleListFromArticleListAllSection, type ArticleListLatestFragment} from './query';

type Props = {
	data: ArticleListLatestFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const ArticleListLatestContainer: FC<Props> = ({
	data,
	fullWidth,
	anchorHeadings,
	insideToc,
}) => {
	const {articles} = articleListFromArticleListAllSection(data);

	let limitedArticles = articles;

	if (data.limit && data.limit > 0) {
		limitedArticles = articles.slice(0, data.limit);
	} else {
		limitedArticles = articles.splice(0, 3);
	}

	return (
		<ArticleList
			articles={limitedArticles}
			heading={data.heading}
			description={
				data.description && data.description.length > 0 ? (
					<PortableText
						value={data.description}
						overrideClassNames={articleListLatestDescriptionPortableTextOverrides}
					/>
				) : null
			}
			anchorHeadings={anchorHeadings}
			options={{
				fullWidth,
				...data.contentBlockOptions,
			}}
			insideToc={insideToc}
		/>
	);
};
